export default "__VITE_ASSET__DosyiyFE__"